import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Impressão de atestado e logo são servidos pelo quarkus.
const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useAttestedPrint() {
  const [isLoading, setLoading] = useState(false);

  const fetchAttestedToPrint = useCallback((patientId, attestedId) => {
    setLoading(true);
    return quarkusApi
      .get(`/atestado/${patientId}/${attestedId}/print`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const fetchLogo = useCallback(() => {
    return quarkusApi.get('/clinic/logo', authHeader());
  }, []);

  return { fetchAttestedToPrint, fetchLogo, isLoading };
}
